import gql from 'graphql-tag';

export default gql`
  mutation SocialLogin(
    $email: String!
    $id: String!
    $provider: String!
    $firstName: String!
    $lastName: String!
    $imageUrl: String
  ) {
    loginOrRegister(
      email: $email
      id: $id
      provider: $provider
      firstName: $firstName
      lastName: $lastName
      imageUrl: $imageUrl
    ) {
      token
    }
  }
`;
